<template>
  <div
    class="password-container w-[343px] px-4 py-6 min-h-[195px] rounded-[10px] bg-[#151A1F] border-[1px] border-solid border-[#64F765] flex flex-col justify-center items-center"
  >
    <Image
      :src="close"
      class="w-[24px] h-[24px] !absolute top-2 right-2"
      alt=""
      @click="handleClose"
    />
    <div class="text-white mb-8">{{ $t('Saque.SendPassword.CheckWithdrawalPassword') }}</div>
    <div class="input-box flex justify-between w-full px-2" @click="focusInput">
      <div
        v-for="(_, index) in 6"
        :key="index"
        class="box w-[40px] h-[40px] border-2 border-[#64F765] flex items-center justify-center"
      >
        <span
          v-if="index < password.length"
          class="dot bg-white w-[10px] h-[10px] rounded-full"
        ></span>
      </div>
    </div>
    <input
      ref="hiddenInput"
      type="number"
      class="hidden-input absolute opacity-0 pointer-events-none"
      v-model="password"
      maxlength="6"
      @input="handleInput"
    />

    <div
      v-if="passwordError"
      class="text-[13px] flex gap-2 text-[#FF3B30] leading-[18px] mt-4"
    >
      <Image class="w-[16px] h-[16px]" :src="sigh" alt="" />
      <span> {{ $t('Saque.SendPassword.PasswordErrorMessage') }}</span>
    </div>

    <button
      @click="handleConfirm"
      :disabled="password.length !== 6"
      :class="[
        'w-full h-[42px] mt-8 block mx-auto rounded-lg border-[1px] bg-[#151A1F] border-solid text-center border-[#fff]/50',
        password.length == 6 ? 'bg-[#64F765]  text-[#151A1F]' : '',
      ]"
    >
    {{ $t('Common.Confirm') }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { checkWithdrawalPassword } from "@/api/saque";
import sigh from "./../images/sigh.png";
import close from "./../images/close.png";
import { encryptPassword } from "@/utils";
const hiddenInput = ref<HTMLInputElement | null>(null);
const password = ref("");
const emit = defineEmits(["confirm", "close"]);
const passwordError = ref(false);
const focusInput = () => {
  hiddenInput.value?.focus();
};

const handleInput = (event: Event) => {
  const input = event.target as HTMLInputElement;
  password.value = input.value.slice(0, 6);
};

const handleClose = () => {
  emit("close");
};
// 校验密码
const handleConfirm = async () => {
  const res: any = await checkWithdrawalPassword({
    value: encryptPassword(password.value),
  });
  if (res.code === 1) {
    emit("confirm", encryptPassword(password.value));
  } else {
    passwordError.value = true;
  }
};

onMounted(() => {
  focusInput();
});
</script>

<style scoped lang="scss">
.password-container {
  position: relative;
  .box {
    background-color: #2c795266;
  }
  .confirm-button:disabled {
    background-color: #555;
    cursor: not-allowed;
  }
}
</style>
